// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IFieldValidator } from "./IFieldValidator"


interface VatinFieldValidatorArguments {
    code: string
    errorMessages?: {[key: string]: string | React.ReactNode}
}


export class VatinFieldValidator implements IFieldValidator {
  private code: string
  private errorMessages: {[key: string]: string | React.ReactNode}

  constructor(opts: VatinFieldValidatorArguments) {
    const kwargs = opts || {}
    this.code = kwargs.code
    this.errorMessages = kwargs.errorMessages || {
        invalid: "INVALID"
    }
  }

  getErrorMessage(code: string): string | React.ReactNode {
    return this.errorMessages[code] || this.errorMessages["invalid"]
  }

  validate(value: string | null | undefined): (string|React.ReactNode)[] {
    if (!value) {
      return [this.getErrorMessage("required")]
    }
    if (!value.startsWith(this.code)) {
      return [this.getErrorMessage("invalidStartCode")]
    }
    if (!value.match(/^[A-Z0-9]+$/i)) {
      return [this.getErrorMessage("invalidCharacters")]
    }
    return []
  }
}